module.exports = __webpack_public_path__ + "static/NewBanner-ad7dc18962c4382de42c2bab1c107668.png";